// Project.ts
import { Permissions } from "./PermissionEnum";
import UserGroup from "./UserGroup";
export default class Project
{
	constructor();
	constructor(name : string);
	constructor(name? : string)
	{
		this.name = name || "";
	}

	get pid() : string 
	{
        return this.id;
    }

	id = "";
	name = "";
	description = "";
	watermarkImage = "";
	watermarkLink = "";
	creation : Date = new Date();
	data = "";
	upgradedOverride = false;

	/** local user's group */
	group : UserGroup = <UserGroup><unknown>null;

	/** all groups */
	groups : [UserGroup] = <[UserGroup]><unknown>null;

	/** 
	 * TODO: this is now hooked up like it is in the Unity codebase and is correct, 
	 * but to stay consistent with what's been done so far, use `group` instead 
	 */
	localPermissions : Permissions = Permissions.None;

	/** populated via a Vuex action getProjectSubscription */
	subscriptionTier : number = 0;
}